import { Component, OnInit, ViewContainerRef, ViewChild, ChangeDetectorRef, Injector } from '@angular/core';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { CommunicationService } from 'src/modules/base/services/communication.service';
import { AlertsService } from 'src/modules/base/services/alerts.service';
import { SmartModalService } from 'src/modules/base/services/smart-modal.service';
import { LoaderService } from 'src/modules/base/services/loader.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DialogConfig } from '../../dialog/dialog-config';
import { DialogService } from '../../dialog/dialog.service';
import { DialogRef } from '../../dialog/dialog-ref';
import { FormComponent } from '../../form/form.component';
@Component({
    selector: 'app-dynamic-pop-up',
    templateUrl: './dynamic-pop-up.component.html',
    styleUrls: ['./dynamic-pop-up.component.scss'],
    standalone: false
})
export class DynamicPopUpComponent implements OnInit {
  data: any;
  _currentData: any = {};
  _currentAction = 'ADD';
  customButton: any = {};
  application: any;
  id: any = [];
  actionType: any;
  config: any;
  @ViewChild('formComponenet') formComponent: FormComponent;
  @ViewChild('customComponent', { read: ViewContainerRef }) customComponent: ViewContainerRef;
  btn: any;

  constructor(
    private baseService: BaseService,
    private communicationService: CommunicationService,
    private alerts: AlertsService,
    private SmartModalService: SmartModalService,
    private loader: LoaderService,
    public injector: Injector,
    public viewContainerRef: ViewContainerRef,
    private router: ActivatedRoute,
    private route: Router,
    private dialogConfig: DialogConfig,
    private dialogRef: DialogRef,
    private cdRef: ChangeDetectorRef,
  ) { }
  ngOnInit() {
    //this.data = this['data'];
    this.data = this.dialogConfig;
    const hideAdd = this?.data?.action?.hideAddButton;
    this.btn = this.data['action'] != undefined && this.data['action'].form != undefined && this.data['action'].form.buttons ? this.data['action'].form.buttons : {
      "Add": hideAdd ? [] : [
                {
                  label: "Submit",
                  icon: "fa fa-check"
                }
              ],
      "Modify": [
        {
          "label": "Submit",
          "icon": "fa fa-check"
        }
      ]
    };
    if (this.data['selector'] == undefined) {
      //this.data = this.dialogConfig;
      console.log("dddddd", this.dialogConfig);
      this.data = this.dialogConfig.data ? this.dialogConfig.data : this.dialogConfig;
      if (this.data['selector'] == undefined) {
        this.getFormData();
      }
    }
  }
  ngAfterViewInit() {
    if (this.data['selector'] != undefined) {
      this.baseService.createComponent(this.data['selector'], this.customComponent, (response: any) => {
        if (this.data != undefined && this.data.action != undefined && this.data.action.SetObj != undefined && this.data.action.SetObj) {
          this.data.action.SetObj['data'] = this.data.item;
          response.instance.data = this.data.action.SetObj;
          response.instance.ehr_view_default = this.data['ehr_view_default'];
          if (this['data'] != undefined && this['data'].currentForm != undefined) {
            response.instance.form = {currentForm:this.data['currentForm'],form:this.data['form'],value:this.data['selectedItemsValue']?this.data['selectedItemsValue']:[]};
            response.instance.indices = {selectedIndices: this.data['selectedIndices']};
            response.instance.parentForm = {parentForm: this.data['parentForm'], editableGrid: this.data['editableGrid']};
            response.instance.items = {selectedItems: this.data['selectedItems']};
          }

        }
        else {
          response.instance.data = this.data['item'];
          response.instance.action = this.data['action'];
          response.instance.ehr_view_default = this.data['ehr_view_default'];
          if (this['data'] != undefined && this['data'].currentForm != undefined) {
            response.instance.form = {currentForm:this.data['currentForm'],form:this.data['form'],value:this.data['selectedItemsValue']?this.data['selectedItemsValue']:[]};
            response.instance.indices = {selectedIndices:this.data['selectedIndices']};
            response.instance.parentForm = {parentForm: this.data['parentForm'], editableGrid: this.data['editableGrid']};
            response.instance.items = {selectedItems: this.data['selectedItems']};
          }
        }

        this.cdRef.detectChanges();
      });
    }
    this.loader.hideSpinner()
  }
  getFormData() {
    this.config = {
      "submitButton": true,
      "filterForm": false,
      "clearOnSave": true,
      "delegateSave": true,
      "cancelRoute": '',
      "compositearray_action": 'ADD'
    }
    if (this.data['action'] && this.data['action'].config != undefined && this.data['action'].config){
        this.config = Object.assign(this.config, this.data['action'].config);
    }
    if (this.data['action'] && this.data['action'].decorator != undefined) {
      this._currentData.decorator = this.baseService.initDecorator(this.data['action'].decorator, this.route, this.injector);
    }
    this._currentData._currentData = this.data['val']
    console.log("data at popup is as::", this.data);
    if (this._currentData.decorator && this._currentData.decorator.setData)
      this._currentData.decorator.setData(this.data['val']);
    this.id = "";
    for (let i = 0; i < this.data['val']?.length; i++) {
      if (this.data['val'].length == i) {
        this.id = this.id;
      }
      else {
        if (i == 0 && this.data['val'][i].id != undefined) {
          this.id = this.data['val'][i].id;
        }
        else if (this.data['val'][i].id != undefined) {
          this.id = this.id + "," + this.data['val'][i].id;
        }
      }
    }
    if (this.data['actiontype']) {
      this.actionType = this.data['actiontype'];
    }
    this._currentData._currentFormFields = this.data['action']['form'];

    // setForm decorator implemented
    if (this._currentData.decorator && this._currentData.decorator.setForm)
      this._currentData.decorator.setForm(this._currentData, this.data['action']);
    // this.customButton = this.data['action']['popup']['custom_button'];
  }
  onSaveFinished(event: any) {
    if (this.data['action'] && this.data['action'].decorator != undefined) {
      this._currentData.decorator.beforeSubmitRequest(event, this._currentData._currentData);
    }
    if (this.data['action'] && this.data['action'].sendData != undefined  && this.data['action'].sendData) {
      event.data = this.data;
      this.SmartModalService.sendResult(event);
      this.dialogRef.close(event);
      return;
    }
    this.loader.showSpinner();
    switch (event.currentBtnVal.action) {
      case "Add":
        this.addPopupData(event);
        break;
      case "delete":
        this.baseService.action({ id: this.id }, 'SOFT_DELETE').subscribe(
          (data: any) => {
            this.loader.hideSpinner();
            if (data.erroCode == -1) {
              this.alerts.error(data.message);
            } else {
              this.alerts.success("Deleted Successfully");
              this.SmartModalService.sendResult(data);
              // this.bindGrid();
            }
          }, error => {
            console.log(error);
            this.alerts.error('API error');
            this.loader.hideSpinner();
          }
        )
        break;
      //can be used to send frm data only
      case "prePrint":
        this.SmartModalService.sendResult(event.result);
        this.dialogRef.close();
        break;
      default:
        if (this.actionType) {
          this.bulkAction(event);
        } else {
          this.addPopupData(event);
        }
        break;
    }

  }
  addPopupData(event) {
    // debugger;
    let resource = this.data['action']['resource'] != undefined ? this.data['action']['resource'] : '';
    let application = this.data['action']['application'] != undefined ? this.data['action']['application'] : '';
    let apiAction = this.data['action']['api_action'] != undefined ? this.data['action']['api_action'] : this._currentAction;
    let append_required = (this.data['action']['append_required'] == undefined) ? true : this.data['action']['append_required'];
    let required_api_call = (this.data['action']['required_api_call'] == undefined) ? true : this.data['action']['required_api_call'];
    var data;
    if (append_required == undefined || append_required) {
      // data = Object.assign(this.data['val'], event.result);
      let data_ = JSON.parse(JSON.stringify(this.data.val));
      data = Object.assign(data_, event.result);
    }
    else {
      data = event.result;
    }

    if (required_api_call == false) {
      this.communicationService.emitChange({ completed: true });
      if (this.data['action'].hasOwnProperty('successMessage')) {
        this.alerts.success(this.data['action']['successMessage']);
      } else {
        this.alerts.success("Added Successfully");
      }
      /******** DEOCRATOR IMPLEMENTATION *******/
      if (this._currentData.decorator != undefined && this._currentData.decorator) {
        this._currentData.decorator.afterSubmitReqSuccess(event, data, this.formComponent);
      }
      if (this.data['action'].hasOwnProperty('redirectLink')) {
        let url = ''
        if (this.route.url.includes('?')) {
          if (this.route.url.split('?')[0] == this.data['action'].redirectLink) {
            url = this.route.url;
            this.route.navigate(["/search"]).then(() => {
              this.route.navigateByUrl(url);
            });
          }
        } else {
          if (this.route.url == this.data['action'].redirectLink) {
            url = this.route.url;
            this.route.navigate(["/search"]).then(() => {
              this.route.navigateByUrl(url);
            });
          } else {
            url = this.data['action'].redirectLink;
            this.route.navigateByUrl(url);
          }
        }
      }
      this.SmartModalService.sendResult(data);
      this.dialogRef.close();
      return;
    }

    this.baseService.action(data, apiAction, application, resource).subscribe(
      (data: any) => {
        this.loader.hideSpinner();
        if (data.errCode == -1) {
          this.alerts.error(data.message);
          if(this.data && this.data.action && this.data.action.check_validation){return}else{
            this.dialogRef.close();
          }
          if (this.data && this.data['action'] && this.data['action']['refreshGrid']) {
            this.SmartModalService.sendResult(data);
          }
        }
        else {
          this.communicationService.emitChange({ completed: true });
          if (this.data['action'].hasOwnProperty('successMessage')) {
            this.alerts.success(this.data['action']['successMessage']);
          } else {
            this.alerts.success("Added Successfully");
          }
          /******** DEOCRATOR IMPLEMENTATION *******/
          if (this._currentData.decorator != undefined && this._currentData.decorator) {
            this._currentData.decorator.afterSubmitReqSuccess(event, data, this.formComponent);
          }
          if (this.data['action'].hasOwnProperty('redirectLink')) {
            let url = ''
            if (this.route.url.includes('?')) {
              if (this.route.url.split('?')[0] == this.data['action'].redirectLink) {
                url = this.route.url;
                this.route.navigate(["/search"]).then(() => {
                  this.route.navigateByUrl(url);
                });
              }
            } else {
              if (this.route.url == this.data['action'].redirectLink) {
                url = this.route.url;
                this.route.navigate(["/search"]).then(() => {
                  this.route.navigateByUrl(url);
                });
              } else {
                url = this.data['action'].redirectLink;
                this.route.navigateByUrl(url);
              }
            }
          }
          this.SmartModalService.sendResult(data);
          this.dialogRef.close();
        }
        
      }, error => {
        this.alerts.error('API error');
        this.loader.hideSpinner();
      }
    )
  }

  bulkAction(event: any) {
    let resource = this.data['action']['resource'] != undefined ? this.data['action']['resource'] : '';
    let application = this.data['action']['application'] != undefined ? this.data['action']['application'] : '';
    let apiAction = this.data['action']['api_action'] != undefined ? this.data['action']['api_action'] : this._currentAction;
    let obj = { id: this.id }
    var sendobj = { ...obj, ...event.result };
    this.data['sendobj'] = sendobj;     // for doing crud operation on sendobj data
    /******** DEOCRATOR IMPLEMENTATION *******/
    if (this.data['action'] && this.data['action'].decorator != undefined) {
        var submitRes = this._currentData.decorator.beforeOnSubmit(this.data, this.data.action);
        if (!submitRes) {
          return;
        }
    }
    /******** DEOCRATOR IMPLEMENTATION *******/
    this.baseService.action(this.data.sendobj, apiAction, application, resource).subscribe(
      (data: any) => {
        this.loader.hideSpinner();
        if (data.errCode == -1) {
          this.alerts.error(data.message);
        } else {
          this.alerts.success("Updated Successfully");
          this.SmartModalService.sendResult(data);
          this.closePopUp();
          // this.bindGrid();
        }
      }, error => {
        console.log(error);
        this.alerts.error('API error');
        this.loader.hideSpinner();
      }
    )
  }

  closePopUp() {
    this.dialogRef.close();
  }
}